function getDataCustomers() {
  const isES = location.pathname.includes('/es');
  const bestSellPrefix = isES ? 'Ranking de tus compras en ' : 'Ranking das suas compras em ';

  const outEl = document.getElementById('bestsellers-customer');
  if (!outEl) return;

  const categoryEl = document.getElementById('collection_category');
  const rawCategory =
    (categoryEl && ('value' in categoryEl ? categoryEl.value : categoryEl.getAttribute('value'))) || document.querySelector(".breadcrumb-wrap")?.querySelector("span")?.textContent?.trim();
  const categoryPage = String(rawCategory || '').replace(/\s+/g, '');
  if (!categoryPage) return;

  const toSlug = (s) => String(s || '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')    // tira acentos/cedilhas
    .replace(/[^a-z0-9]/gi, '')       // remove espaços, hífens, etc.
    .toLowerCase();

  const translateCategoryES = cat => {
    switch (cat) {
      case 'ALIMENTACAO': return 'ALIMENTACIÓN';
      case 'CHARCUTARIA': return 'CHARCUTERÍA';
      case 'DPH': return 'DPH';
      case 'GARRAFEIRA': return 'BODEGA';
      case 'PRODUTOS CONGELADOS': return 'PRODUCTOS CONGELADOS';
      case 'PRODUTOS REFRIGERADOS': return 'PRODUCTOS REFRIGERADOS';
      default: return cat;
    }
  };

  const qs = new URLSearchParams({
    action: 'product_rankings',
    store: String(STORE ?? ''),
    email: String(CEMAIL2 ?? ''),
  });
  const url = `${ENDPOINT}?${qs.toString()}`;

  let arrayData = [];

  fetch(url, { headers: { Accept: 'application/json' } })
    .then(res => (res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} - ${t}`); })))
    .then(payload => {
      const data = payload?.data || null;
      if (!data) return;

      arrayData = Object.keys(data).map(k => ({ key: k, value: data[k] }));

      try {
        localStorage.setItem('product_rankings_customer', JSON.stringify(arrayData));
      } catch (e) {
        console.warn('Não foi possível gravar em localStorage:', e);
      }
    })
    .catch(err => {
      try {
        const cached = JSON.parse(localStorage.getItem('product_rankings_customer') || '[]');
        if (Array.isArray(cached)) arrayData = cached;
      } catch (e) {
        console.error(e)
      }
    })
    .then(() => {
      if (!Array.isArray(arrayData) || arrayData.length === 0) return;

      arrayData.forEach(item => {
        const category = String(item.key ?? '');
        const catSlug   = toSlug(category);
        const pageSlug  = toSlug(categoryPage);

        if (catSlug !== pageSlug) return;

        const products = item.value || {};
        const productIds = [];

        const categoryTranslated = isES ? translateCategoryES(category) : category;

        let html = `
          <div class="collection-product" id="category-${category}">
            <div class="page-width slider-newproduct-wrap">
              <div class="container" style="position:relative">
                <div class="section-header">
                  <h2 class="tt-title">${bestSellPrefix}${categoryTranslated}</h2>
                </div>
                <div class="customNavigation bestsellers hideme ">
                  <div class="navigation_wrap">
                    <a class="prev mdi-chevron-left" data-nav="prev">{{ 'general.slider.prev' | t }}</a>
                    <a class="next mdi-chevron-right" data-nav="next">{{ 'general.slider.next' | t }}</a>
                  </div>
                </div>
                <div class="row">
                  <div class="new-product-div container" id="${catSlug}">
                    <div id="bestseller-products" class="grid grid--view-items"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>`;

        Object.entries(products).forEach(([, value]) => {
          if (value != null) productIds.push(`gid://shopify/Product/${value}`);
        });

        outEl.innerHTML = html;
        if (typeof fetchData === 'function') {
          try { fetchData(productIds); } catch (e) { console.error('fetchData falhou:', e); }
        }

        const navWrap = outEl.querySelector('.navigation_wrap');
        if (navWrap && !navWrap.__wired) {
          navWrap.__wired = true;
          navWrap.addEventListener('click', ev => {
            const prev = ev.target.closest('[data-nav="prev"]');
            const next = ev.target.closest('[data-nav="next"]');

            if (prev && typeof prevProd === 'function') {
              ev.preventDefault();
              prevProd(prev); // adapta se a tua função espera jQuery
            } else if (next && typeof nextProd === 'function') {
              ev.preventDefault();
              nextProd(next);
            }
          });
        }
      });
    });
}

function fetchData(ids) {
  if (!Array.isArray(ids) || ids.length === 0) return;

  const uniqueIds = [...new Set(ids.filter(Boolean))];
  if (uniqueIds.length === 0) return;

  const catEl = document.getElementById('collection_category');
  const rawCat = catEl ? (('value' in catEl) ? catEl.value : catEl.getAttribute('value')) : '';
  const categoryPage = String(rawCat || '').replace(/\s+/g, '');

  const SHOPIFY_STORE_URL = 'https://marvanejo.myshopify.com/api/2023-01/graphql.json';
  const ACCESS_TOKEN = '79e400f4830ffd97c633bbda35f0e5d2';

  const query = `
    {
      nodes(ids: ${JSON.stringify(uniqueIds)}) {
        ... on Product {
          id
          title
          handle
          availableForSale
          tags
          productType
          featuredImage {
            url
            altText
          }
          variants(first: 1) {
            edges {
              node {
                id
                sku
                priceV2 { amount }
                compareAtPriceV2 { amount }
              }
            }
          }
        }
      }
    }
  `;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN,
    },
    body: JSON.stringify({ query }),
  };

  fetch(SHOPIFY_STORE_URL, options)
    .then(res => (res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })))
    .then(json => {
      if (json.errors) {
        console.error('GraphQL errors:', json.errors);
        return;
      }

      if (typeof generateCategoryHTML === 'function') {
        generateCategoryHTML(json, categoryPage);
      } else {
        console.warn('generateCategoryHTML não está definido.');
      }
    })
    .catch(console.error);
}

function generateCategoryHTML(data, category) {
  const products = data?.data?.nodes || [];
  if (!Array.isArray(products) || products.length === 0) return;

  const escId = s => String(s || '').replace(/[^\w-]/g, '_');
  const catId = escId(category);
  const carouselId = `carousel_products_${catId}`;

  const priceHTML = (sku, amount) => {
    const iecas = loadFromMemory("iecas") ?? {}
    const prices = loadFromMemory("prices") ?? {}

    const productPrice = iecas[sku] ?? prices[sku]
    const finalPrice = isNaN(parseFloat(productPrice)) ? amount : productPrice

    return `
      <span class="custom-price product-price__price" data-price="${finalPrice}" data-sku="${sku}">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      `
  };

  const productCard = (item) => {
    if (!item) return '';

    const {
      variants = [],
      availableForSale = false,
      tags = [],
      id = null,
      featuredImage = null,
      handle = "",
      title = ""
    } = item ?? {};
  
    const prodId = String(id || '').replace('gid://shopify/Product/', '');
    const variant = variants?.edges?.[0]?.node || {};

    const price = variant.priceV2?.amount ?? '';
    const compareAt = variant.compareAtPriceV2?.amount ?? null;

    const soldOut = availableForSale === false ? 'sold-out' : '';
    const onSale = compareAt && Number(compareAt) > Number(price) ? 'on-sale' : '';

    let unity_measure = '';
  
    for (const t of (tags ?? [])) {
      if (t && t.includes('unity_measure_')) {
        unity_measure = t.replace('unity_measure_', '');
        break;
      }
    }

    const featuredImageURL = featuredImage?.url ||
      'https://portal.marvanejo.pt/cdn/shop/files/logo_marvanejo-_1_5_96445930-c4db-4c87-bbef-117a909b53a7_220x.jpg?v=1643391456';
    const featuredAlt = featuredImage?.altText || 'product image';

    return `
      <div class="grid-item p-0">
        <div data-id="product-${prodId}" class="grid-view-item product-layouts item-row ${soldOut} ${onSale}">
          <div class="product-wrapper">
            <div class="thumbs product-thumb">
              <div class="product-image col-xs-12 padding_0">
                <a href="/products/${handle}" class="product-t">
                  <img src="${featuredImageURL}" alt="${featuredAlt}" class="featured-image image_thumb"/>
                </a>
              </div>
            </div>

            <div class="product-description">
              <div class="product-description-wrap">
                <div class="price-btn">
                  <div class="grid-view-item__vendor grid-item-meta prod_item_title" style="text-align:left">
                    <a class="grid-view-item__link grid-link__title" href="/products/${handle}">
                      ${title}
                    </a>
                  </div>

                  <div class="grid-view-item__meta">
                    <div class="grid-link__org_price" style="float:left">
                      ${priceHTML(variant.sku || '', price)}
                    </div>

                    <div class="pro_btn add_tocart" style="display:flex; align-items:center; justify-content:flex-end;">
                      <div class="qnty_grid" style="position:relative; width:100px;">
                        <input type="number" min="1" step="1" class="form-control" sku-value="${variant.sku || ''}" value="1"
                               style="margin-bottom:0;width:100%;height:40px;text-align:center; padding:0 40px;font-size:18px">
                        <div class="quantity-nav" style="position:absolute; top:0; right:-25%; height:100%; width:100%; pointer-events:none;">
                          <span class="quantity-button quantity-down" data-role="qty-down"
                                style="position:absolute; left:0; top:0; height:100%; width:30px; display:flex; align-items:center; justify-content:center; pointer-events:all; border:none; font-size:20px">-</span>
                          <span class="quantity-button quantity-up" data-role="qty-up"
                                style="position:absolute; right:0; top:0; height:100%; width:30px; display:flex; align-items:center; justify-content:center; pointer-events:all; border:none; font-size:20px">+</span>
                        </div>
                      </div>
                      /${unity_measure || ''}
                      <form action="/cart/add" method="post" class="variants clearfix cart-form-${prodId}">
                        ${unity_measure ? `<input type="hidden" name="properties[Unity of Measure]" value="${unity_measure}">` : ''}
                        <input type="hidden" name="id" value="${prodId}">
                        <a href="#" class="add-to-basket" data-add="${variant.sku || ''}" data-image="${featuredImageURL}">
                          <img src="https://cdn.shopify.com/s/files/1/0288/6559/3432/files/icon.png?v=1718362406" width="50" style="width:50px!important"/>
                        </a>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const html = `
    <div class="row">
      <div class="product-grid carousel_bestsellers" id="${carouselId}" data-flickity='{ "groupCells": true }'>
        ${products.map(productCard).join('')}
      </div>
    </div>
  `;

  const target = document.querySelector('#bestseller-products');
  if (!target) return;
  target.innerHTML = html;

  const carouselEl = document.getElementById(carouselId);
  if (carouselEl && Flickity) {
    try {
      new Flickity(carouselEl, { cellAlign: 'left', contain: true, pageDots: false });
    } catch (e) {
      console.warn('Flickity init falhou:', e);
    }
  }

  if (carouselEl && !carouselEl.__wired) {
    carouselEl.__wired = true;

    carouselEl.addEventListener('click', (e) => {
      const down = e.target.closest('[data-role="qty-down"]');
      const up   = e.target.closest('[data-role="qty-up"]');
      const add  = e.target.closest('a.add-to-basket');

      if (down || up) {
        e.preventDefault();

        if (typeof changeQntyGrid === 'function') {
          try { changeQntyGrid(e.target); } catch (err) { console.error('changeQntyGrid falhou:', err); }
        } else {
          const grid = e.target.closest('.qnty_grid');
          const input = grid?.querySelector('input[type="number"]');
          if (input) {
            const step = Number(input.step || 1);
            const min = Number(input.min || 1);

            let val = Number(input.value || 1);
            val += up ? step : -step;

            if (!Number.isFinite(val)) val = min;

            input.value = Math.max(min, val);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        return;
      }

      if (add) {
        e.preventDefault();
        if (typeof addToBasketRanking === 'function') {
          try { addToBasketRanking(add); } catch (err) { console.error('addToBasketRanking falhou:', err); }
        }
      }
    });
  }

  if (CID2) {
    let id = CID2;

    try {
      const buyerData = JSON.parse(localStorage.getItem('selectedAgentData') || 'null');
      if (buyerData?.[0]?.buyerId) id = buyerData[0].buyerId;
    } catch {}

    let prices = (typeof loadFromMemory === 'function') ? loadFromMemory('prices') : null;

    const applyPrices = (payload) => {
      if (typeof customPrices === 'function') {
        try { 
          customPrices(payload || prices); 
        } catch (e) { 
          console.error('customPrices falhou:', e); 
        }
      }
    };

    if (!prices || (Array.isArray(prices) && prices.length === 0)) {
      if (!id) return;
      showLoadingModal('A carregar preços...');

      const qs = new URLSearchParams({ store: '0', action: 'customer_prices', id: String(id) });
      fetch(`${ENDPOINT}?${qs.toString()}`, { headers: { Accept: 'application/json' } })
        .then(res => (res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} - ${t}`); })))
        .then(data => {
          removeLoadingModal();
          applyPrices(data);
        })
        .catch(err => {
          console.error('customer_prices erro:', err);
          showLoadingModal('Não foi possível carregar as preços');
          removeLoadingModal();
        });
    } else {
      applyPrices(prices);
    }
  }
}

function addToBasketRanking(product) {
  // Normalizar para Element do DOM
  const toEl = (x) => {
    if (!x) return null;
    if (x instanceof Element) return x;          // já é DOM
    if (x.jquery) return x[0] || null;           // jQuery -> DOM
    if (x.target) {                              // Event
      const tgt = x.currentTarget instanceof Element ? x.currentTarget : x.target;
      return tgt instanceof Element ? tgt.closest('a') || tgt : null;
    }
    return null;
  };

  const el = toEl(product);
  if (!el) return;

  // Encontrar o "scope" e garantir que é um Element
  let scope = el.closest('.pro_btn') || el.parentElement?.parentElement || el;
  if (!(scope instanceof Element)) return;

  // Agora é seguro usar querySelector
  const qtyInput = scope.querySelector('input[type="number"]');
  const qty = Number(qtyInput?.value || 1);

  if (typeof addToBasket === 'function') {
    // Se precisares passar jQuery ao addToBasket, embrulha aqui
    const arg = (window.$ && typeof window.$ === 'function') ? $(el) : el;
    try {
      addToBasket(arg, qty);
    } catch (err) {
      console.error('addToBasket falhou:', err);
    }
  }
}

function getCategoryDivFromTrigger(triggerEl) {
  if (!triggerEl) return null;

  let node = triggerEl;
  while (node && node !== document.body && !node.classList.contains('container')) {
    node = node.parentElement;
  }

  return node ? node.querySelector('.new-product-div') : null;
}

function prevProd(trigger) {
  const el = trigger?.target ? trigger.target : trigger;
  const categoryDiv = getCategoryDivFromTrigger(el);
  const catId = categoryDiv?.id;
  if (!catId) return;

  const prevBtn = document.querySelector(`#${CSS.escape(catId)} .flickity-prev-next-button.previous`);
  if (prevBtn) prevBtn.click();
}

function nextProd(trigger) {
  const el = trigger?.target ? trigger.target : trigger;
  const categoryDiv = getCategoryDivFromTrigger(el);
  const catId = categoryDiv?.id;
  if (!catId) return;

  const nextBtn = document.querySelector(`#${CSS.escape(catId)} .flickity-prev-next-button.next`);
  if (nextBtn) nextBtn.click();
}
